import { useEffect, useState } from "react";
import "./App.css";
import AppRoutes from "./Routes/AppRoutes";
import "./offline.css";
function App() {
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    function handleOnlineStatus() {
      setIsOnline(window.navigator.onLine);
    }

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOnlineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOnlineStatus);
    };
  }, []);
  return (
    <>
      {isOnline ? (
        <div className="App">
          <AppRoutes />
        </div>
      ) : (
        <div className="main-wrapper offline">
          <div class="wrapper">
            <h1>OFFLINE</h1>
            <h4>Please check your internet connection</h4>
            <a href="." class="button">
              RETRY
            </a>
          </div>
        </div>
      )}
    </>
  );
}

export default App;
